import { authFetch } from './base';
import { buildUrlPath } from 'lib/resolveUrl';
const agentBase = (eventId) => `api/events/${eventId}/agent`;
export const fetchAgentThreads = async (eventId) => {
    const response = await authFetch(`${agentBase(eventId)}/threads`);
    if (!response.ok)
        throw new Error('Failed to load threads');
    const payload = await response.json();
    return payload.data;
};
export const fetchAgentThread = async (eventId, threadId) => {
    const response = await authFetch(`${agentBase(eventId)}/threads/${threadId}`);
    if (!response.ok)
        throw new Error('Failed to load thread');
    const payload = await response.json();
    return payload.data;
};
export const deleteAgentThread = async (eventId, threadId) => {
    const response = await authFetch(`${agentBase(eventId)}/threads/${threadId}`, { method: 'DELETE' });
    if (!response.ok)
        throw new Error('Failed to delete thread');
};
export async function* streamAgentMessage(eventId, threadId, content, signal) {
    const url = buildUrlPath(`${agentBase(eventId)}/threads/${threadId}/messages`);
    const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream' },
        body: JSON.stringify({ content }),
        signal,
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Agent request failed');
    }
    const reader = response.body?.getReader();
    if (!reader)
        throw new Error('No response body');
    const decoder = new TextDecoder();
    let buffer = '';
    while (true) {
        const { done, value } = await reader.read();
        if (done)
            break;
        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split('\n\n');
        buffer = parts.pop() ?? '';
        for (const part of parts) {
            const lines = part.split('\n');
            let eventName = 'message';
            let dataLine = '';
            for (const line of lines) {
                if (line.startsWith('event: '))
                    eventName = line.slice(7).trim();
                if (line.startsWith('data: '))
                    dataLine = line.slice(6);
            }
            if (!dataLine)
                continue;
            try {
                yield { event: eventName, data: JSON.parse(dataLine) };
            }
            catch {
                yield { event: eventName, data: dataLine };
            }
        }
    }
}
